import React from "react";
import Icon from "./icon";
export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Nossos Serviços</h2>
          <p>
          Auxiliamos os clientes a atingirem os seus objetivos com criação ou melhorias das ferramentas utilizadas.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-6">
                  {/* <i className={d.icon}></i> */}
                  <Icon name={d.icon} className="custom"></Icon>
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
